import * as FilteringState from '../../../Data/FilteringState'
import {update} from '../../../Data/ObjectHelper'
import * as PrismaRequestFilter from './PrismaRequestFilter'
import * as PrismaRequestFilterInput from './PrismaRequestFilterInput'
import * as PrismaRequestFilterInputAction
    from './PrismaRequestFilterInputAction'
import * as PrismaRequestFilterType from './PrismaRequestFilterType'

export type M =
    FilteringState.M<PrismaRequestFilter.M, PrismaRequestFilterType.M, PrismaRequestFilterInput.M>

export function init(activeFilters: PrismaRequestFilter.M[]): M {
    return FilteringState.init(
        PrismaRequestFilter.inactiveFilterTypes,
        activeFilters,
    )
}

export function submit(state: M): M {
    return FilteringState.submit(
        PrismaRequestFilter.fromFilterInput,
        PrismaRequestFilter.toFilterType,
        state,
    )
}

export function clearFilters(state: M): M {
    return FilteringState.clearFilters(
        PrismaRequestFilterType.all(),
        state,
    )
}

export function removeFilter(
    filterType: PrismaRequestFilterType.M,
    state: M
): M {
    return FilteringState.removeFilter(
        PrismaRequestFilter.toFilterType,
        PrismaRequestFilterType.sort,
        filterType,
        state,
    )
}

export function reduceFilterInputChanged(
    inputAction: PrismaRequestFilterInputAction.M,
    state: M
): M {
    return FilteringState.reduceFilterInputChanged(
        (action, filterInput) => {
            switch (action.type) {
                case 'BpsUserChanged':
                    return filterInput.type === 'BpsUserFilterInput' ?
                        update({selectedBpsUser: action.value}, filterInput) :
                        filterInput
                case 'CreatedFromChanged':
                    return filterInput.type === 'CreatedFromFilterInput' ?
                        update({value: action.value}, filterInput) :
                        filterInput
                case 'CreatedToChanged':
                    return filterInput.type === 'CreatedToFilterInput' ?
                        update({value: action.value}, filterInput) :
                        filterInput
                case 'StatusChanged':
                    return filterInput.type === 'StatusFilterInput' ?
                        update({value: action.value}, filterInput) :
                        filterInput
            }
        },
        inputAction,
        state,
    )
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Components/PrismaRequestFiltering/Model/PrismaRequestFilteringState.ts